import $http from "../axios";

const state = {
  stockouts: []
};

const getters = {
  stockouts: state => {
    return state.stockouts;
  }
};

const actions = {
  getStockouts({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(`stockouts?beginDate=${data.dates[0]}&endDate=${data.dates[1]}`)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_STOCKOUTS", res.data.payload);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_STOCKOUTS(state, payload) {
    state.stockouts = payload.stockouts;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
